import React, { useEffect, useState } from "react";
import services from "../../services/services";
import { Navigate, useLocation } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";

const ProtectedRoute = ({ children }) => {
	let location = useLocation();
	const { features, setFeatures, setLoadingFeatures } = useAppContext();
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const checkAuthAndFetchFeatures = async () => {
			setIsLoading(true);
			const token = sessionStorage.getItem("ags_token");

			if (token) {
				setIsAuthenticated(true);
				if (!features || features.length === 0) {
					setLoadingFeatures(true);
					try {
						const response = await services.getFeatures();
						console.log("Fetched features:", response);
						setFeatures(response);
					} catch (error) {
						console.error("Error fetching features:", error);
					} finally {
						setLoadingFeatures(false);
					}
				}
			} else {
				setIsAuthenticated(false);
			}
			setIsLoading(false);
		};

		checkAuthAndFetchFeatures();
	}, [setFeatures, setLoadingFeatures, features]);

	if (isLoading) {
		return (
			<div style={{ textAlign: "center", padding: "10em" }}>Loading...</div>
		); // Or your custom loading component
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	return children;
};

export default ProtectedRoute;
